module.exports = __webpack_public_path__ + "static/media/earth.cbb02b72.png";